<template>
  <component :doLoadComponent="loadComponent" :renderData="renderData" :is="selectedComponent"></component>
</template>

<script>

import axios from "axios";

export default {
    name: 'EliWrapperComponent',
  data() {
    return {
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      selectedComponent: null,
      renderData: null
    };
  },
  mounted() {
    this.loadComponent();
  },
  methods: {
    loadComponent() {
      var level = this.$route.params.level
        ? this.$route.params.level + "/"
        : "";
      var issueType = this.$route.params.issueType
        ? this.$route.params.issueType + "/"
        : "";
      var authority = this.$route.params.authority
        ? this.$route.params.authority + "/"
        : "";
      var docType = this.$route.params.docType
        ? this.$route.params.docType + "/"
        : "";
      var authorityOrDocType = this.$route.params.authorityOrDocType
        ? this.$route.params.authorityOrDocType + "/"
        : "";
      var gazetteYear = this.$route.params.gazetteYear
        ? this.$route.params.gazetteYear + "/"
        : "";
      var gazetteNumber = this.$route.params.gazetteNumber
        ? this.$route.params.gazetteNumber + "/"
        : "";
      var number = this.$route.params.number
        ? this.$route.params.number + "/"
        : "";
      var formatOrServiceOrTimestamp1 = this.$route.params.formatOrServiceOrTimestamp1
        ? this.$route.params.formatOrServiceOrTimestamp1 + "/"
        : "";
      var formatOrServiceOrTimestamp2 = this.$route.params.formatOrServiceOrTimestamp2
        ? this.$route.params.formatOrServiceOrTimestamp2 + "/"
        : "";
      var formatOrServiceOrTimestamp3 = this.$route.params.formatOrServiceOrTimestamp3
        ? this.$route.params.formatOrServiceOrTimestamp3
        : "";
      var authorityDoctype;
      if (docType && authority) authorityDoctype = `${authority}${docType}`;
      else authorityDoctype = `${authorityOrDocType}`;

      var eliLink = `eli/${level}${issueType}${authorityDoctype}${gazetteYear}${gazetteNumber}${number}${formatOrServiceOrTimestamp1}${formatOrServiceOrTimestamp2}${formatOrServiceOrTimestamp3}`;

      axios.get(this.baseSLGLApiUrl + "prins/" + eliLink).then((response) => {
        if (response.data.eliPathResultType || response.data.eliPathResultType === 0 ) {
          import("../base_pages/reg/EliViewActPage.vue").then((c) => {
            this.selectedComponent = c.default;
            this.renderData = response.data; 
             if (response.data.eliUrl && response.data.eliUrl !== eliLink) {
               this.$router.replace({ path: response.data.eliUrl });
            }
          });
        } else if(formatOrServiceOrTimestamp1.toLowerCase() === 'sg/' || formatOrServiceOrTimestamp2.toLowerCase() === 'sg/' || formatOrServiceOrTimestamp3.toLowerCase() === 'sg') {
          if((formatOrServiceOrTimestamp1.toLowerCase() === 'html/' || formatOrServiceOrTimestamp2.toLowerCase()  === "html/" || formatOrServiceOrTimestamp3.toLowerCase() === 'html') && response.data.contentUrl === undefined) {
              window.document.write(response.data);
          } else {
            import("../base_pages/slglrs/ViewActPage.vue").then((c) => {
              this.selectedComponent = c.default;
              this.renderData = response.data; 
              if (response.data.eliUrl && response.data.eliUrl !== eliLink) {
                this.$router.replace({ path: response.data.eliUrl });
              }
            });
          }
        } else {
          import("../base_pages/reg/ViewActPage.vue").then((c) => {
            this.selectedComponent = c.default;
            this.renderData = response.data; 
             if (response.data.eliUrl && response.data.eliUrl !== eliLink) {
                this.$router.replace({ path: response.data.eliUrl });
              }
          });
        }
      }).catch(error => {
        if(error.response.status === 403 || error.response.status === 401)
          window.location.href = '/';
          else {
            error.response && document.write(error.response.data +  `<b>${eliLink}</b>`);
          }
      });

    },
  },
};
</script>
